<template>
  <div class="collapse-container" :class="data.fields.styleInstructions">
    <div class="padding-bottom-2 padding-top-3 text-right"  >
      <!-- pooja, 19-dec-25, 508 show on DOM only when the text is needed to be announced. -->
      <div  v-if="announceToggle" aria-live="polite" class="sr-only">
        {{ liveMessage }}
      </div>
      <button 
        :aria-label="`${showlabel} ${expandAll ? 'expanded' : 'collapsed'}`"
        type="button"
        @click="toggle()"
        class="usa-button usa-button--unstyled text-black text-bold text-no-underline hover:text-black cgi-toggle-all"
        data-scope="#toggle-group-2"
        :class="{
          'cgi-toggle-all--expanded': expandAll,
          'cgi-toggle-all': !expandAll,
        }"
      >
      <!-- pooja, 23-jun-25, 508 to read collapsable all -->
        <span class="cgi-toggle-all__is-collapsed" aria-hidden="true">
          <span class="svg-1em">
            <svg width="24" height="24" viewBox="0 0 512 512" role="img" focusable="false" >
              <title aria-hidden="true" >Expand all</title>
              <desc  aria-hidden="true">Expand all</desc>
              <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"></path>
            </svg>
          </span>
          <span class="padding-left-05">{{ translationKeywords['expand-all'] || 'Expand all' }}</span>
        </span>
        <span class="cgi-toggle-all__is-expanded" aria-hidden="true">
          <span class="svg-1em">
            <svg width="24" height="24" viewBox="0 0 512 512" role="img" focusable="false" >
              <title aria-hidden="true" >Collapse all</title>
              <desc aria-hidden="true">Collapse all</desc>
              <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"></path>
            </svg>
          </span>
          <span class="padding-left-05">{{ translationKeywords['collapse-all'] || 'Collapse all' }}</span>
        </span>
      </button>
    </div>
    <div :key="i" v-for="(step, i) of data.fields.collapsableCardReferences">
      <div :key="j" v-for="(step2, j) of step">
        <document-renderer
          :documentId="step2.id"
          :additionaldata="{ encapsulator: encapsulator }"
        ></document-renderer>
      </div>
    </div>
  </div>
</template>

<script>
import { getTranslationKeywords } from "@/store/api";
import { urlLangCode, urlSlug } from "@/helpers/url";
import { LABEL_FOR_STEP_5_EXPAND_ALL } from "@/config";

export default {
  name: "collapsable-encapsulator",
  props: ["data"],
  data() {
    return {
      expandAll: false,
      encapsulator: this,
      translationKeywords: {},  
      announceToggle: false,
      liveMessage: ""
    };
  },
  methods: {
  toggle() {
    this.expandAll = !this.expandAll;    
    this.$emit(this.expandAll ? "expand-all" : "collapse-all");
    this.liveMessage = `${this.showlabel} ${
      this.expandAll ? "expanded" : "collapsed"
    }`;
    this.announceToggle = true;
    this.$nextTick(() => {
      setTimeout(() => {
        this.announceToggle = false;
        this.liveMessage = "";
      }, 500);
    });
  }
},
  // pooja, 23-jun-25, 508 to read collapsable all
  computed: {
    encapsulator() {
      return this.additionaldata && this.additionaldata.encapsulator;
    },
    showlabel() {
      const urlSlugText = urlSlug();
      if (urlSlugText == "step-5") return LABEL_FOR_STEP_5_EXPAND_ALL;
    },
  },
  beforeCreate() {
    getTranslationKeywords(urlLangCode()).then(
      (keywords) => (this.translationKeywords = keywords)
    );
  },
};
</script>
 
<style scoped>
.medium-center {
  width: 100%;
  margin: 0 auto;
}
.collapse-container {
  margin-bottom: 50px;
}
</style>
